import { SyntheticEvent, useState } from 'react';

import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { TabsPanel } from 'design-system/TabPanel/TabPanel';

import PageTopBar from 'components/Topbar/PageTopBar';

enum EPlayersState {
  BLOCKED = 'blocked'
}

export const PlayersView = () => {
  const { publisherId, portalId } = useParams();
  const navigate = useNavigate();
  const [tab, setTab] = useState<EPlayersState>(EPlayersState.BLOCKED);

  const basePath = publisherId ? `/project/${publisherId}` : `/portal/${portalId}`;

  const getPlayersPath = (basePath: string, state: EPlayersState) => `${basePath}/players/${state}`;

  const handleTabChange = (event: SyntheticEvent, newValue: EPlayersState) => {
    setTab(newValue);
    navigate(getPlayersPath(basePath, newValue));
  };

  const tabs = [{ label: 'Blocked players', value: EPlayersState.BLOCKED }];

  return (
    <TabsPanel
      tabs={tabs}
      headerComponent={<PageTopBar withTabsDesign={true} headline="Players" />}
      handleTabChange={handleTabChange}
      activeTabVal={tab}
    />
  );
};
